export default "__VITE_ASSET__3db05c0b__"